import { defineHistoryService } from '@feature-hub/history-service';
import { defineLogger } from '@feature-hub/logger';
import { serializedStateManagerDefinition } from '@feature-hub/serialized-state-manager';
import { defineAuthService } from '@oneaudi/audi-auth-service';
import { defineCookieService } from '@oneaudi/audi-cookie-service';
import { defineEnvConfigService } from '@oneaudi/audi-env-config-service';
import { defineNotificationDisplayService } from '@oneaudi/audi-notification-display-service';
import { defineContentService } from '@oneaudi/content-service';
import { defineCurrentCarlineService } from '@oneaudi/current-carline-service';
import { defineAudiFootnoteReferenceService } from '@oneaudi/footnote-reference-service';
import { defineGfaServiceConfigProvider } from '@oneaudi/gfa-service-config-provider';
import { defineAudiHeaderStateService } from '@oneaudi/header-state-service';
import { defineI18nService } from '@oneaudi/i18n-service';
import { defineNumberFormatterService } from '@oneaudi/number-formatter-service';
import { defineOneGraphService } from '@oneaudi/onegraph-service';
import { pubSubFeatureService } from '@oneaudi/pubsub-service';
import { defineUserVehicleFeatureService } from '@oneaudi/user-vehicle-feature-service';
import { defineVueFormatterService } from '@oneaudi/vue-formatter-service';
import { defineAudiMarketContextService } from '@oneaudi/market-context-service';
import { layerManagerDefinition } from '@volkswagen-onehub/layer-manager';
import { defineGfaLocalService, defineLocaleService, } from '@volkswagen-onehub/locale-service';
import { createFeatureServiceBundle } from '../types/feature-service-bundle';
import { defineGfaNavigationService, defineNavigationService, } from '@volkswagen-onehub/navigation-service';
export const sharedBundle = createFeatureServiceBundle({
    'audi:envConfigService': defineEnvConfigService,
    'audi-content-service': defineContentService,
    'audi-current-carline-service': defineCurrentCarlineService,
    'audi-footnote-reference-service': defineAudiFootnoteReferenceService,
    'audi-header-state-service': defineAudiHeaderStateService,
    'audi-market-context-service': defineAudiMarketContextService,
    'audi-number-formatter-service': defineNumberFormatterService,
    'cookie-service': defineCookieService,
    'dbad:audi-i18n-service': defineI18nService,
    'dbad:audi-vue-formatter-service': defineVueFormatterService,
    'gfa:locale-service': defineGfaLocalService,
    'gfa:navigation-service': defineGfaNavigationService,
    'gfa:service-config-provider': defineGfaServiceConfigProvider,
    'layer-manager': layerManagerDefinition,
    'locale-service': defineLocaleService,
    'navigation-service': defineNavigationService,
    'notification-display-service': defineNotificationDisplayService,
    'onegraph-service': defineOneGraphService,
    'pubsub-service': pubSubFeatureService,
    's2:history': defineHistoryService,
    's2:logger': defineLogger,
    's2:serialized-state-manager': serializedStateManagerDefinition,
    'user-vehicle-feature-service': defineUserVehicleFeatureService,
    'vw:authService': defineAuthService,
});
//# sourceMappingURL=shared.js.map